import React, { useContext } from "react";
import { IonList, IonItem, IonImg } from "@ionic/react";
import "./EsperiHeader.css";
import { getLogo } from 'util/Branding';
import { UserContext } from 'providers/User';

const EsperiHeaderWithoutNavigation = () => {
  const { state } = useContext(UserContext);

  return (
    <IonList className="ion-no-border" lines="none">
      <IonItem className="withoutNavigationTopSpacer" />
      <IonImg className="withoutNavigationTitle" src={getLogo(state.business)} />
      <IonItem className="withoutNavigationBottomSpacer" />
    </IonList>
  );
};

export default EsperiHeaderWithoutNavigation;
